<template>
  <div class="messageContent">
    <!-- 烟花 -->
    <div class="myCanvas">
      <canvas id="fireworks"></canvas>
    </div>
    <!-- 留言滚动 -->
    <div class="message">
      <vue-baberrage
        :isShow="barrageIsShow"
        :barrageList="barrageList"
        :loop="barrageLoop"
        :startTime="startTime"
        :lanesCount="lanesCount"
        style="position: absolute; top: 0; left: 0"
      >
      </vue-baberrage>
    </div>
    <!-- 留言滚动 -->
    <div class="message">
      <vue-baberrage
        :isShow="barrageIsShow"
        :barrageList="RealTime"
        :loop="barrageLoop"
        :startTime="startTime"
        :lanesCount="lanesCount"
        style="position: absolute; top: 0; left: 0"
      >
      </vue-baberrage>
    </div>
    <!-- 输入留言 -->
    <div class="inputMessage">
      <span @click="dialogVisible = true">留言</span>
      <el-divider direction="vertical"></el-divider>

      <span @click="goHomePage">首页</span>
    </div>
    <!-- 留言弹窗 -->
    <el-dialog title="留言" :visible.sync="dialogVisible" width="30%">
      <el-input v-model="input" placeholder="请输入留言内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="messageInput">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 图片绘制logo -->
    <LogoCanvas style="margin-left: 600px" />
    <!-- 扫描二维码组件 -->
    <!-- <QrCode /> -->
  </div>
</template>

<script>
import LogoCanvas from "@/components/LogoCanvas/LogoCanvas";
import QrCode from "@/components/QrCode/QrCode";
export default {
  name: "HelloWorld",
  components: { LogoCanvas, QrCode },
  data() {
    return {
      barrageLoop: false,
      barrageIsShow: true,
      dialogVisible: false,
      currentId: 1,
      startTime: "0",
      input: "",
      lanesCount: 5,
      barrageList: [],
      RealTime: [],
      messageList: [
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "富强民主文明和谐11111111",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "富强民主文明和谐22222222",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "富强民主文明和谐3333333",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "富强民主文明和谐444444444",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "富强民主文明和谐5555555555",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "富强民主文明和谐",

          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "哈哈哈哈哈哈哈",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "23333333333",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "挺好玩的",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "有人吗",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "下次一定",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "略略略略~~~",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "挺好玩的",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "有人吗",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "下次一定",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "略略略略~~~",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "挺好玩的",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "有人吗",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "下次一定",
          time: Math.random() * 5 + 10,
        },
        {
          id: ++this.currentId,
          // avatar: "https://www.liurulan.cn/ball.png",
          msg: "略略略略~~~",
          time: Math.random() * 5 + 10,
        },
      ],
    };
  },
  mounted() {
    this.yanhua();
    this.addToList();
  },
  methods: {
    yanhua() {
      var SCREEN_WIDTH = window.innerWidth,
        SCREEN_HEIGHT = window.innerHeight,
        mousePos = {
          x: 400,
          y: 300,
        },
        // create canvas
        canvas = document.getElementById("fireworks"),
        context = canvas.getContext("2d"),
        particles = [],
        rockets = [],
        MAX_PARTICLES = 400,
        colorCode = 0;

      // init
      window.onload = function () {
        canvas.width = SCREEN_WIDTH;
        canvas.height = SCREEN_HEIGHT;
        setInterval(launch, 800);
        setInterval(loop, 1000 / 50);
      };

      function launch() {
        launchFrom(mousePos.x);
      }

      function launchFrom(x) {
        if (rockets.length < 10) {
          var rocket = new Rocket(x);
          rocket.explosionColor = Math.floor((Math.random() * 360) / 10) * 10;
          rocket.vel.y = Math.random() * -3 - 4;
          rocket.vel.x = Math.random() * 6 - 3;
          rocket.size = 8;
          rocket.shrink = 0.999;
          rocket.gravity = 0.01;
          rockets.push(rocket);
        }
      }

      function loop() {
        // update screen size
        if (SCREEN_WIDTH !== window.innerWidth) {
          canvas.width = SCREEN_WIDTH = window.innerWidth;
        }
        if (SCREEN_HEIGHT !== window.innerHeight) {
          canvas.height = SCREEN_HEIGHT = window.innerHeight;
        }

        // clear canvas
        // context.fillStyle = "rgba(0, 0, 0, 0.05)";
        var gradientLinear = context.createLinearGradient(0, 0, 0, 100);
        gradientLinear.addColorStop(0, "rgb(255, 58, 58)");
        gradientLinear.addColorStop(1, "rgba(255, 149, 63, 0.89)");
        context.fillStyle = gradientLinear;

        context.fillRect(0, 0, SCREEN_WIDTH, SCREEN_HEIGHT);

        var existingRockets = [];

        for (var i = 0; i < rockets.length; i++) {
          // update and render
          rockets[i].update();
          rockets[i].render(context);

          // calculate distance with Pythagoras
          var distance = Math.sqrt(
            Math.pow(mousePos.x - rockets[i].pos.x, 2) +
              Math.pow(mousePos.y - rockets[i].pos.y, 2)
          );

          // random chance of 1% if rockets is above the middle
          var randomChance =
            rockets[i].pos.y < (SCREEN_HEIGHT * 2) / 3
              ? Math.random() * 100 <= 1
              : false;

          /* Explosion rules
     - 80% of screen
     - going down
     - close to the mouse
     - 1% chance of random explosion
     */
          if (
            rockets[i].pos.y < SCREEN_HEIGHT / 5 ||
            rockets[i].vel.y >= 0 ||
            distance < 50 ||
            randomChance
          ) {
            rockets[i].explode();
          } else {
            existingRockets.push(rockets[i]);
          }
        }

        rockets = existingRockets;

        var existingParticles = [];

        for (var i = 0; i < particles.length; i++) {
          particles[i].update();

          // render and save particles that can be rendered
          if (particles[i].exists()) {
            particles[i].render(context);
            existingParticles.push(particles[i]);
          }
        }

        // update array with existing particles - old particles should be garbage collected
        particles = existingParticles;

        while (particles.length > MAX_PARTICLES) {
          particles.shift();
        }
      }

      function Particle(pos) {
        this.pos = {
          x: pos ? pos.x : 0,
          y: pos ? pos.y : 0,
        };
        this.vel = {
          x: 0,
          y: 0,
        };
        this.shrink = 0.97;
        this.size = 2;

        this.resistance = 1;
        this.gravity = 0;

        this.flick = false;

        this.alpha = 1;
        this.fade = 0;
        this.color = 0;
      }

      Particle.prototype.update = function () {
        // apply resistance
        this.vel.x *= this.resistance;
        this.vel.y *= this.resistance;

        // gravity down
        this.vel.y += this.gravity;

        // update position based on speed
        this.pos.x += this.vel.x;
        this.pos.y += this.vel.y;

        // shrink
        this.size *= this.shrink;

        // fade out
        this.alpha -= this.fade;
      };

      Particle.prototype.render = function (c) {
        if (!this.exists()) {
          return;
        }

        c.save();

        c.globalCompositeOperation = "lighter";

        var x = this.pos.x,
          y = this.pos.y,
          r = this.size / 2;

        var gradient = c.createRadialGradient(x, y, 0.1, x, y, r);
        gradient.addColorStop(0.1, "rgba(255,255,255," + this.alpha + ")");
        gradient.addColorStop(
          0.8,
          "hsla(" + this.color + ", 100%, 50%, " + this.alpha + ")"
        );
        gradient.addColorStop(1, "hsla(" + this.color + ", 100%, 50%, 0.1)");

        c.fillStyle = gradient;

        c.beginPath();
        c.arc(
          this.pos.x,
          this.pos.y,
          this.flick ? Math.random() * this.size : this.size,
          0,
          Math.PI * 2,
          true
        );

        c.closePath();
        c.fill();

        c.restore();
      };

      Particle.prototype.exists = function () {
        return this.alpha >= 0.1 && this.size >= 1;
      };

      function Rocket(x) {
        Particle.apply(this, [
          {
            x: x,
            y: SCREEN_HEIGHT,
          },
        ]);

        this.explosionColor = 0;
      }

      Rocket.prototype = new Particle();
      Rocket.prototype.constructor = Rocket;

      Rocket.prototype.explode = function () {
        var count = Math.random() * 10 + 80;

        for (var i = 0; i < count; i++) {
          var particle = new Particle(this.pos);
          var angle = Math.random() * Math.PI * 2;

          // emulate 3D effect by using cosine and put more particles in the middle
          var speed = Math.cos((Math.random() * Math.PI) / 2) * 15;

          particle.vel.x = Math.cos(angle) * speed;
          particle.vel.y = Math.sin(angle) * speed;

          particle.size = 10;

          particle.gravity = 0.2;
          particle.resistance = 0.92;
          particle.shrink = Math.random() * 0.05 + 0.93;

          particle.flick = true;
          particle.color = this.explosionColor;

          particles.push(particle);
        }
      };

      Rocket.prototype.render = function (c) {
        if (!this.exists()) {
          return;
        }

        c.save();

        c.globalCompositeOperation = "lighter";

        var x = this.pos.x,
          y = this.pos.y,
          r = this.size / 2;

        var gradient = c.createRadialGradient(x, y, 0.1, x, y, r);
        gradient.addColorStop(0.1, "rgba(255, 255, 255 ," + this.alpha + ")");
        gradient.addColorStop(1, "rgba(0, 0, 0, " + this.alpha + ")");

        c.fillStyle = gradient;

        c.beginPath();
        c.arc(
          this.pos.x,
          this.pos.y,
          this.flick
            ? (Math.random() * this.size) / 2 + this.size / 2
            : this.size,
          0,
          Math.PI * 2,
          true
        );
        c.closePath();
        c.fill();

        c.restore();
      };
    },
    // yanhua() {
    //   function getStyle(obj, attr) {
    //     if (window.getComputedStyle) {
    //       return window.getComputedStyle(obj)[attr];
    //     } else {
    //       return obj.currentStyle[attr];
    //     }
    //   }
    //   function bufferMove(obj, json, fn) {
    //     let speed = 0;
    //     clearInterval(obj.timer);
    //     obj.timer = setInterval(function () {
    //       var flag = true;
    //       for (var attr in json) {
    //         var currentValue = null;
    //         if (attr === "opacity") {
    //           currentValue = Math.round(getStyle(obj, attr) * 100);
    //         } else {
    //           currentValue = parseInt(getStyle(obj, attr));
    //         }
    //         speed = (json[attr] - currentValue) / 10;
    //         speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);

    //         if (currentValue !== json[attr]) {
    //           if (attr === "opacity") {
    //             obj.style.opacity = (currentValue + speed) / 100;
    //             obj.style.filter =
    //               "alpha(opacity=" + (currentValue + speed) + ")"; //IE
    //           } else {
    //             obj.style[attr] = currentValue + speed + "px";
    //           }
    //           flag = false;
    //         }
    //       }
    //       if (flag) {
    //         clearInterval(obj.timer);
    //         fn && typeof fn === "function" && fn();
    //       }
    //     }, 10);
    //   }
    //   class Firework {
    //     constructor(x, y) {
    //       //x,y鼠标的位置
    //       this.x = x; //将水平位置赋值给this.x属性。
    //       this.y = y; //将垂直位置赋值给this.y属性。
    //       this.ch = document.documentElement.clientHeight; //可视区的高度
    //     }
    //     init() {
    //       //1.创建烟花节点。
    //       this.firebox = document.createElement("div");
    //       this.firebox.style.cssText = `width:5px;height:5px;background:#fff;position:absolute;left:${this.x}px;top:${this.ch}px;`;
    //       document.body.appendChild(this.firebox);
    //       this.firemove(); //创建完成，直接运动。
    //     }
    //     //2.烟花节点运动
    //     firemove() {
    //       bufferMove(this.firebox, { top: this.y }, () => {
    //         document.body.removeChild(this.firebox);
    //         //当烟花节点消失的时候，创建烟花碎片
    //         this.createfires();
    //       });
    //     }
    //     //3.当前鼠标点击的位置，随机产生30-60个盒子。(随机颜色)
    //     createfires() {
    //       for (let i = 1; i <= this.rannum(30, 60); i++) {
    //         this.fires = document.createElement("div");
    //         this.fires.style.cssText = `width:5px;height:5px;background:rgb(${this.rannum(
    //           0,
    //           255
    //         )},${this.rannum(0, 255)},${this.rannum(
    //           0,
    //           255
    //         )});position:absolute;left:${this.x}px;top:${this.y}px;`;
    //         document.body.appendChild(this.fires);
    //         this.fireboom(this.fires); //设计成一个一个运动，等到循环结束，出现整体结果。
    //       }
    //     }
    //     //4.烟花碎片运动。
    //     fireboom(obj) {
    //       //存储当前obj的初始值。
    //       let initx = this.x;
    //       let inity = this.y;

    //       //随机产生速度(水平和垂直方向都是随机的,符号也是随机的)。
    //       let speedx = parseInt(
    //         (Math.random() > 0.5 ? "-" : "") + this.rannum(1, 15)
    //       );
    //       let speedy = parseInt(
    //         (Math.random() > 0.5 ? "-" : "") + this.rannum(1, 15)
    //       );

    //       obj.timer = setInterval(() => {
    //         initx += speedx;
    //         inity += speedy++; //模拟重力加速度(垂直方向比水平方向快一些)
    //         if (inity >= this.ch) {
    //           document.body.removeChild(obj);
    //           clearInterval(obj.timer);
    //         }
    //         obj.style.left = initx + "px";
    //         obj.style.top = inity + "px";
    //       }, 1000 / 60);
    //     }
    //     //随机区间数
    //     rannum(min, max) {
    //       return Math.round(Math.random() * (max - min) + min);
    //     }
    //   }

    //   document.onclick = function (ev) {
    //     var ev = ev || window.event;
    //     //ev.clientX,ev.clientY//获取的鼠标的位置
    //     new Firework(ev.clientX, ev.clientY).init();
    //   };
    // },
    addToList() {
      var i = 0;
      setInterval(() => {
        if (i >= this.messageList.length) {
          i = 0;
        }
        this.barrageList.push(this.messageList[i]);
        i++;
      }, 1000);
    },
    messageInput() {
      this.RealTime.push({
        id: ++this.currentId,
        // avatar: "https://www.liurulan.cn/ball.png",
        msg: this.input,
        time: Math.random() * 5 + 5,
      });
      this.dialogVisible = false;
    },
    goHomePage() {
      this.$router.push({ name: "homePage" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
.messageContent {
  // background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100vh;
  .myCanvas {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background: linear-gradient(
      to bottom right,
      rgb(255, 58, 58),
      rgba(255, 149, 63, 0.89)
    );
    // background-color: #000;
    z-index: 10;
  }

  .baberrage-item .normal {
    background: linear-gradient(left, #fff, rgba(0, 0, 0, 0)) !important;
    color: black !important;
    padding-right: 50px;
  }
  .message {
    .baberrage-stage {
      // z-index: 9999999999;
      z-index: 20;
      margin-top: 100px;
      width: 100%;
      height: 50%;
    }
  }
  .inputMessage {
    position: fixed !important;
    padding: 10px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;

    background: rgba(255, 255, 2550, 0.2);
    z-index: 11;
    top: 0;
    left: 0;
    span {
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/welcomePage/welcomePage.vue